import React, {useEffect, useRef} from "react";
import ReactDOM from "react-dom";
import Wishlist from "./Wishlist";
import styles from "./Wishlist.module.scss";
import NotloggedinModal from "./Modals/NotloggedinModal";
import {useWishlistContext} from "./WishlistContextProvider/WishlistContextProvider";
import {useCustomerContext} from "../customer/CustomerContextProvider/CustomerContextProvider";
import WishlistIsFullModal from "./Modals/WishlistIsFullModal";
import AddedToWishlistModal from "./Modals/AddedToWishlistModal";

const WishlistPortal: React.FC = () => {
  const {customer} = useCustomerContext();
  const wishlistElem = document.querySelector<HTMLDivElement>(".wishlist");
  const wishlistIcon = document.querySelector<HTMLAnchorElement>(".header-wishlist");
  const {wishlist, isNotLoggedInModalShown, itemIdAddedByUrl, setIsNotLoggedInModalShown, setItemIdAddedByUrl} = useWishlistContext();
  const wishlistIntentRef = useRef<boolean>(false);

  const redirectToWishlist = () => {
    location.href = wishlistIcon?.href ?? "";
  };

  const redirectToWishlistOnIntent = () => {
    if (wishlistIntentRef.current) {
      redirectToWishlist();
    }
  };

  const redirectFromAddedPopup = () => {
    if (itemIdAddedByUrl) setItemIdAddedByUrl(undefined);
    redirectToWishlist();
  };

  const closeNotLoggedInModal = () => {
    setIsNotLoggedInModalShown(false);
    if (wishlistElem) {
      location.href = document.referrer || location.origin;
    }
  };

  // show modal on certain conditions when customer is not logged in
  useEffect(() => {
    // when customer navigates to 'wunschlisten.html' by link/bookmark
    if (!customer.isLoggedIn && !!wishlistElem) {
      wishlistIntentRef.current = true;
      setIsNotLoggedInModalShown(true);
    }

    // on wishlist heart click
    const loginOrRedirect = (event: MouseEvent) => {
      event.preventDefault();
      wishlistIntentRef.current = true;
      if (!customer.isLoggedIn) {
        setIsNotLoggedInModalShown(true);
      } else {
        redirectToWishlistOnIntent();
      }
    };
    if (wishlistIcon) wishlistIcon.addEventListener("click", loginOrRedirect);

    return () => {
      if (wishlistIcon) wishlistIcon.removeEventListener("click", loginOrRedirect);
    };
  }, [customer.isLoggedIn]);

  if (!wishlistIcon) {
    return null;
  }

  // badge with item count
  const Badge: React.FC = () => (
    <span className={styles.badgeGreen} style={{width: (wishlist?.items.length ?? 0) > 99 ? "20px" : "14px"}}>
      {wishlist?.items.length}
    </span>
  );

  return (
    <React.Fragment>
      {!!wishlist?.items.length && ReactDOM.createPortal(<Badge />, wishlistIcon)}
      {!!wishlistElem && ReactDOM.createPortal(<Wishlist />, wishlistElem)}
      {/*/ show modal when user is not logged in and wants to enter wishlist */}
      <NotloggedinModal
        isVisible={isNotLoggedInModalShown}
        closeFunction={closeNotLoggedInModal}
        onLoggedIn={redirectToWishlistOnIntent}
      />
      <WishlistIsFullModal />
      <AddedToWishlistModal continueFunction={redirectFromAddedPopup} />
    </React.Fragment>
  );
};

export default WishlistPortal;
